"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../../createApi");

var ChallengesApi = function (_BaseApi) {
  (0, _inherits2["default"])(ChallengesApi, _BaseApi);

  function ChallengesApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ChallengesApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ChallengesApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getChallenges", function (_ref) {
      var clientId = _ref.clientId,
          groupId = _ref.groupId,
          withHidden = _ref.withHidden,
          limit = _ref.limit,
          skip = _ref.skip,
          type = _ref.type,
          timeframe = _ref.timeframe;
      return _this.api.get("/v3/challenges?client=".concat(clientId), {
        params: {
          client: clientId,
          groupId: groupId,
          withHidden: withHidden,
          limit: limit,
          skip: skip,
          type: type,
          timeframe: timeframe
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getChallengesList", function (_ref2) {
      var clientId = _ref2.clientId,
          limit = _ref2.limit,
          skip = _ref2.skip,
          status = _ref2.status,
          containRegistered = _ref2.containRegistered,
          search = _ref2.search;
      return _this.api.get('/v3/challenges/list', {
        params: {
          clientId: clientId,
          limit: limit,
          skip: skip,
          status: status,
          containRegistered: containRegistered,
          search: search
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getChallengesAdmin", function (_ref3) {
      var clientId = _ref3.clientId,
          groupId = _ref3.groupId,
          limit = _ref3.limit,
          skip = _ref3.skip,
          search = _ref3.search,
          timeframe = _ref3.timeframe,
          type = _ref3.type,
          sort = _ref3.sort,
          segment = _ref3.segment;
      return _this.api.get("/v3/admin/challenges?client=".concat(clientId), {
        params: {
          skip: skip,
          groupId: groupId,
          limit: limit,
          isAdmin: true,
          search: search,
          timeframe: timeframe,
          type: type,
          sort: sort,
          segment: segment
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getChallenge", function (_ref4) {
      var clientId = _ref4.clientId,
          challengeId = _ref4.challengeId;
      return _this.api.get("/v3/challenges/".concat(challengeId, "?client=").concat(clientId));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getChallengeUsers", function (_ref5) {
      var clientId = _ref5.clientId,
          challengeId = _ref5.challengeId,
          status = _ref5.status,
          limit = _ref5.limit,
          skip = _ref5.skip;
      return _this.api.get("/v3/challenges/".concat(challengeId, "/users"), {
        params: {
          'client-id': clientId,
          status: status,
          limit: limit,
          skip: skip
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createChallenge", function (_ref6) {
      var clientId = _ref6.clientId,
          payload = _ref6.payload;
      return _this.api.post('/v3/challenges/', {
        params: {
          'client-id': clientId
        },
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getChallengeStatus", function (_ref7) {
      var clientId = _ref7.clientId,
          challengeId = _ref7.challengeId,
          groupId = _ref7.groupId,
          globalCounter = _ref7.globalCounter;
      var globalCountryParam = globalCounter ? "&globalCounter=".concat(globalCounter) : '';
      return groupId ? _this.api.get("/v3/challenges/".concat(challengeId, "/group/").concat(groupId, "/status?clientId=").concat(clientId).concat(globalCountryParam)) : _this.api.get("/v3/challenges/".concat(challengeId, "/status?clientId=").concat(clientId));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getChallengeProducts", function (_ref8) {
      var challengeId = _ref8.challengeId;
      return _this.api.get("/v3/challenges/".concat(challengeId, "/products"));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editChallenge", function (_ref9) {
      var clientId = _ref9.clientId,
          challengeId = _ref9.challengeId,
          payload = _ref9.payload;
      return _this.api.put("/v3/challenges/".concat(challengeId), {
        params: {
          'client-id': clientId
        },
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateChallengeCodes", function (_ref10) {
      var challengeId = _ref10.challengeId,
          clientId = _ref10.clientId,
          payload = _ref10.payload;
      return _this.api.put("/v3/challenges/".concat(challengeId, "/codes"), {
        params: {
          'client-id': clientId
        },
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteChallenge", function (_ref11) {
      var challengeId = _ref11.challengeId,
          clientId = _ref11.clientId;
      return _this.api["delete"]("/v3/challenges/".concat(challengeId), {
        params: {
          clientId: clientId
        },
        data: {}
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateUserChallenge", function (_ref12) {
      var userId = _ref12.userId,
          clientId = _ref12.clientId,
          challengeId = _ref12.challengeId,
          data = _ref12.data;
      return _this.api.put("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges/").concat(challengeId), {
        params: {
          'client-id': clientId
        },
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "recalculateOneUserChallenge", function (_ref13) {
      var challengeId = _ref13.challengeId,
          clientId = _ref13.clientId,
          userChallengeId = _ref13.userChallengeId;
      return _this.api.get("/v3/challenges/".concat(challengeId, "/calculate/user/").concat(userChallengeId), {
        params: {
          'client-id': clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "recalculateOneGroupChallenge", function (_ref14) {
      var challengeId = _ref14.challengeId,
          clientId = _ref14.clientId,
          groupChallengeId = _ref14.groupChallengeId;
      return _this.api.get("/v3/challenges/".concat(challengeId, "/calculate/group/").concat(groupChallengeId), {
        params: {
          'client-id': clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getProgramChallenges", function (_ref15) {
      var programId = _ref15.programId,
          clientId = _ref15.clientId,
          userId = _ref15.userId;
      return _this.api.get("/v3/programs/".concat(programId, "/challenges"), {
        params: {
          clientId: clientId,
          userId: userId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createProgramChallenges", function (_ref16) {
      var challenges = _ref16.challenges,
          programId = _ref16.programId,
          clientId = _ref16.clientId;
      return _this.api.post('/v3/challenges/bulk', {
        data: challenges,
        params: {
          programId: programId,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editProgramChallenges", function (_ref17) {
      var challenges = _ref17.challenges,
          programId = _ref17.programId,
          clientId = _ref17.clientId;
      return _this.api.put('/v3/challenges/bulk', {
        data: challenges,
        params: {
          programId: programId,
          clientId: clientId
        }
      });
    });
    return _this;
  }

  return ChallengesApi;
}(_createApi.BaseApi);

var _default = ChallengesApi;
exports["default"] = _default;
//# sourceMappingURL=index.js.map